<script setup lang="ts">
import { useRoundsStore } from '@/stores/rounds-store.ts';
import { PBadge, PButton } from '@pokerly/ui';
import PlusIcon from '@/assets/icons/PlusIcon.vue';
import SearchIcon from '@/assets/icons/SearchIcon.vue';
import DotsVerticalIcon from '@/assets/icons/DotsVerticalIcon.vue';
import { computed } from 'vue';

const roundsStore = useRoundsStore();
const totalRounds = computed(() => roundsStore.rounds.length);
const emit = defineEmits<{
    searchClick: [];
}>();
</script>

<template>
    <div class="w-full min-h-12.5 flex items-center p-2 justify-between border-border border-l-2">
        <div class="flex items-center gap-2">
            <span class="font-bold text-sm">Round</span>
            <span class="font-bold text-sm">{{ totalRounds }}/{{ totalRounds }}</span>
            <PBadge variant="secondary">100%</PBadge>
        </div>
        <div class="flex items-center">
            <PButton variant="ghost" size="sm">
                <PlusIcon class="size-4" />
            </PButton>
            <PButton variant="ghost" size="sm" @click="emit('searchClick')">
                <SearchIcon class="size-4" />
            </PButton>
            <PButton variant="ghost" size="sm">
                <DotsVerticalIcon class="size-4" />
            </PButton>
        </div>
    </div>
</template>
